import { LazyComponent, lazyWithNullFallback } from 'components/layout/util';

export const Animation: LazyComponent<{}> = lazyWithNullFallback(() => import('./cart-loading'));
